import './Sentry';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'fastestsmallesttextencoderdecoder';
import ScrollToTop from 'react-router-scroll-top';
import React from 'react';
import { render } from 'react-dom';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { ErrorBoundary } from '@sentry/react';
import './index.css';
import { HashRouter } from 'react-router-dom';
import './i18n';
import * as serviceWorker from './serviceWorker';
import App from './App';

(async () => {
    const LDProvider = await asyncWithLDProvider({
        clientSideID: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID,
    });
    render(
        <ErrorBoundary fallback={<p>An error has occurred.</p>}>
            <LDProvider>
                <HashRouter>
                    <ScrollToTop>
                        <App />
                    </ScrollToTop>
                </HashRouter>
            </LDProvider>
        </ErrorBoundary>,
        document.getElementById('root')
    );
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
